
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 3000 3000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-jupiter",attrs:{"stroke":"#FFF7E3","stroke-width":"277","d":"M1794.82 1141.06a464.5 464.5 0 0 1 138.66 192.05 464.5 464.5 0 0 1 25.93 235.46"}}),_c('path',{staticClass:"i-earth",attrs:{"stroke":"#F1FCFC","stroke-width":"161","d":"M1210.04 1734.37a351.42 351.42 0 0 1-89.14-217.66 351.5 351.5 0 0 1 68.07-225.15"}}),_c('path',{staticClass:"i-venus",attrs:{"stroke":"#F6FBE5","stroke-width":"80","d":"M1448.64 1401.6a110.9 110.9 0 0 1 46.82-12.51c16.34-.67 32.63 2.28 47.69 8.64a111.1 111.1 0 0 1 39.47 28.14 111.04 111.04 0 0 1 23.71 42.27"}}),_c('g',{staticClass:"i-comet clockwise fast",attrs:{"stroke":"#FFE49D"}},[_c('path',{staticClass:"i-Ellipse 653",attrs:{"d":"M1596.9 1257.3a262.3 262.3 0 0 1 104.11 76.71 262.4 262.4 0 0 1 54.85 117.11"}}),_c('circle',{staticClass:"i-Ellipse 655",attrs:{"cx":"1756.5","cy":"1457.11","r":"5.5","transform":"rotate(-10.836 1756.5 1457.11)"}})]),_c('path',{staticClass:"i-mercury counterclockwise fast",attrs:{"stroke":"#D1ED7E","stroke-dasharray":"7 7","d":"M1428.09 1431.23a99.5 99.5 0 0 1 58.01-29.75 99.44 99.44 0 0 1 63.98 12.54 99.53 99.53 0 0 1 42.48 49.47 99.5 99.5 0 0 1 2.73 65.14"}}),_c('path',{staticClass:"i-mars",attrs:{"stroke":"#94CC3F","stroke-dasharray":"1 6","d":"M1471.5 2023.73c-85.73-4.67-169-30.31-242.5-74.67a524.37 524.37 0 0 1-179.08-179.75"}})])
          )
        }
      }
    